import { PublicAgendaItemSchema } from "../../models/agendaItem.schema";

export const AgendaItemControllerResponseSchema = {
  listPublicAgendaItems: PublicAgendaItemSchema.array(),

  getPublicAgendaItem: PublicAgendaItemSchema.nullable(),
};
